export default __webpack_public_path__ + "static/media/croatia.53cd9a97.webp";